// store/routeStore.js
import { defineStore } from 'pinia';

export const useRouteStore = defineStore('route', {
  state: () => ({
    currentRouteName: '',
    fromRouteName: '',
    searchKeyWord: '',
  })
});
